import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uk-container" }
const _hoisted_2 = { class: "uk-card uk-card-secondary uk-card-hover uk-card-body uk-light" }
const _hoisted_3 = {
  id: "payment-form",
  class: "uk-form"
}
const _hoisted_4 = { class: "form-row uk-margin" }
const _hoisted_5 = {
  key: 0,
  class: "uk-margin"
}
const _hoisted_6 = { class: "uk-text-danger" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  "uk-spinner": ""
}
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Enter your card info", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", null, "We will let you know 15 days in advance when we are ready and we are going to charge.", -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Payment processing is PCI Compliant and your data is protected and processed by Stripe", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { id: "card-element" }, null, -1)),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, "Error while adding card: " + _toDisplayString(_ctx.error), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              id: "card-errors",
              role: "alert"
            }, null, -1))
          ]),
          (_ctx.cardAdded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("a", {
                  class: "uk-button uk-button-default uk-button-large",
                  href: "/tracking"
                }, "Track Your Containers Now", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitPayment && _ctx.submitPayment(...args))),
                        class: "uk-button uk-button-primary uk-margin-right",
                        id: "card-button"
                      }, "Add Credit Card"),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.skipPayment && _ctx.skipPayment(...args))),
                        class: "uk-button uk-button-text",
                        id: "card-button"
                      }, "Add credit card later")
                    ]))
              ]))
        ])
      ])
    ])
  ]))
}